/**
 * Точка входа для блока «Принципы / 6 шагов».
 * Pin + смена шагов кроссфейдом (без горизонтальной ленты).
 */
export { initSitePrinciplesCrossfade as initSitePrinciples } from './site-principles-crossfade.js'
